import { useEffect, useState } from "react";
import Spinner from "../Spinner";
import { formatDateTimePretty } from "../../utils/dateUtils";
export const ClinicModal = ({
    open,
    onClose,
    onSubmit,
    initial,
    title,
    submitLabel,
}) => {
    const [clinicId, setClinicId] = useState("");
    const [clinicName, setClinicName] = useState("");
    const [clinicEmail, setClinicEmail] = useState("");
    const [clinicAddress, setClinicAddress] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [isStudy, setIsStudy] = useState(false);

    // Reset form
    const reset = () => {
        setClinicName("");
        setClinicEmail("");
        setClinicAddress("");
        setCreatedAt("");
        setIsStudy(false);
        setError("");
    };

    // Populate fields when editing
    useEffect(() => {
        if (initial) {
            setClinicId(initial.id|| "");
            setClinicName(initial.clinic_name || "");
            setClinicEmail(initial.clinic_email || "");
            setClinicAddress(initial.clinic_address || "");
            setCreatedAt(initial.created_at || "");
            setIsStudy(initial.is_study?.data?.[0] === 1);
        } else {
            reset();
        }
    }, [initial]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);

        try {
            await onSubmit({
                id:clinicId,
                clinic_name: clinicName,
                clinic_email: clinicEmail,
                clinic_address: clinicAddress,
                is_study: isStudy ? 1 : 0,
            });
            reset();
            onClose?.();
        } catch (err) {
            setError("Failed to save clinic. Try again.");
            console.error(err);
        } finally {
            setSubmitting(false);
        }
    };

    if (!open) return null;

    return (
        <div className="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="clinicTitle">
            <div className="modal">
                <div className="modal-header">
                    <h3 id="clinicTitle" style={{ margin: 0 }}>{title}</h3>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {error && <div className="error-message">{error}</div>}
                        <div className="form-row">
                            <label>Clinic Id *</label>
                            <input
                                className="input"
                                type="text"
                                value={clinicId}
                                onChange={(e) => setClinicId(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-row">
                            <label>Clinic Name *</label>
                            <input
                                className="input"
                                type="text"
                                value={clinicName}
                                onChange={(e) => setClinicName(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-row">
                            <label>Clinic Email</label>
                            <input
                                className="input"
                                type="email"
                                value={clinicEmail}
                                onChange={(e) => setClinicEmail(e.target.value)}
                            />
                        </div>

                        <div className="form-row">
                            <label>Clinic Address</label>
                            <textarea
                                className="input"
                                value={clinicAddress}
                                onChange={(e) => setClinicAddress(e.target.value)}
                                rows={2}
                                style={{ resize: "vertical" }}
                            />
                        </div>
                        <div className="form-row">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={submitLabel === "Create" ? true : isStudy}
                                    onChange={(e) => setIsStudy(e.target.checked)}
                                />
                                Is Study
                            </label>
                        </div>


                        <div className="form-row">
                            <label>Created At</label>
                            <input
                                className="input"
                                type="text"
                                value={formatDateTimePretty(createdAt)}
                                readOnly
                                disabled
                            />
                        </div>
                    </div>

                    <div className="modal-actions">
                        <button
                            type="button"
                            className="button secondary"
                            onClick={() => { reset(); onClose?.(); }}
                        >
                            Cancel
                        </button>

                        <button type="submit" className="button primary" disabled={submitting}>
                            {submitting ? (
                                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                                    <Spinner inline size={16} thickness={2} label="Saving" />
                                    Saving...
                                </span>
                            ) : (
                                submitLabel
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
